export const LOCAL_STORAGE = {
    BIZX_ACCESS_TOKEN: 'bizx_access_token',
    BIZX_LOCATION: 'bizx_location',
    MAIN_NAVIGATION: 'main_navigation',
    BIZX_LOCATION_NAME: "bizx_location_name",
    BIZX_LOCATION_CODE: "bizx_location_code",
    IS_BATCH_ENABLED: "is_batch_enabled",
    REPORT_NAVIGATION: "report_navigation"
}